import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./index.scss";
import { HeaderConfig } from "./config";
import { HTTP_METHODS, plainApi } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import ViewTicket from "./view-ticket";
import TicketCard from "./mobile-view-ticket";
import AppContext from "../../utils/context";
import { USER_ROLES } from "../../utils/constants";
import TicketFilters from "../../core/ticket-filters";
import { getOfflineData } from "../../utils/offline-services";
import CustomTable from "../../core/custom-table";
import { PAGE_LIMIT } from "../../utils";

const ServiceTickets = ({ viewTicket, setViewTicket }) => {
  const { userDetails = {} } = useContext(AppContext);
  const navigate = useNavigate();
  const [ticketDetails, setTicketDetails] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [timeline, setTimeline] = useState([]);
  const [mainFilters, setMainFilters] = useState({});
  const [pastTickets, setPastTickets] = useState({
    results: [],
  });
  const [filters, setFilters] = useState({
    page: 1,
    limit: PAGE_LIMIT,
    sortBy: "-createdAt",
  });

  useEffect(() => {
    if (!getOfflineData("user")) {
      navigate("/");
    } else if (userDetails && userDetails.id) {
      loadData(filters);
    }
  }, [userDetails]);

  const loadData = (filters) => {
    setIsLoading(true);
    let url = REST_URLS.LIST_OEM_TICKETS;

    if (userDetails.role === USER_ROLES.ADMIN) {
      url = REST_URLS.TICKETS;
    }
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${url}`, null, filters)
      .then((response) => {
        if (response.results) {
          const result = response.results?.map((ele) => ({
            ...ele,
            serviceEngineer: ele?.serviceEngineer?.name || "Not Assigned",
          }));
          // setPastTickets({ ...response, results: result });
          setPastTickets(response);
        }
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
  };

  const getComplaintDetails = (data) => {
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.COMPLAINT}/${data.id}`,
      null
    )
      .then((response) => {
        if (response) {
          setViewTicket({
            id: data.id,
            ticketId: data.id,
            ...response,
          });
        }
      })
      .catch((err) => console.error(err));
  };
  const getTicketDetails = (id) => {
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.STAGE_VIEW}/${id}`, null)
      .then((response) => {
        if (response) {
          if (response.ticket) {
            setTicketDetails(response.ticket);
          }
          if (response.timeline && Array.isArray(response.timeline)) {
            setTimeline(response.timeline);
          }
        }
      })
      .catch((err) => console.error(err));
  };

  const onRowClick = (data) => {
    if (userDetails.role === USER_ROLES.ADMIN) {
      navigate(`/admin/details/${data.id}`);
    } else {
      getComplaintDetails(data);
      getTicketDetails(data.id);
    }
  };

  return (
    <>
      {!viewTicket?.id ? (
        <div className="service-tickets-container page-load">
          <div className="si-hide-mobile">
            <CustomTable
              header={HeaderConfig}
              data={pastTickets.results || []}
              pageCount={pastTickets.totalPages}
              onClick={onRowClick}
              filters={filters}
              onChange={(page) => {
                setFilters({
                  ...filters,
                  page,
                });
                loadData({
                  ...filters,
                  ...mainFilters,
                  page,
                });
              }}
              filterCom={
                <TicketFilters
                  loadData={loadData}
                  setMainFilters={setMainFilters}
                  filter={filters}
                />
              }
              isLoading={isLoading}
            />
          </div>
          <div className="si-hide-web ">
            <div>
              <TicketFilters
                loadData={loadData}
                setMainFilters={setMainFilters}
                filter={filters}
              />
            </div>
            {pastTickets.results.map((ticket) => {
              return (
                <div key={ticket.id}>
                  <div>
                    <TicketCard
                      onClick={() => onRowClick(ticket)}
                      ticketId={ticket.id}
                      status={ticket.status}
                      createdBy={ticket?.createdBy?.name}
                      assignedTo={ticket?.serviceEngineer?.name}
                      createdOn={ticket.createdAt}
                    ></TicketCard>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <ViewTicket
          details={viewTicket || {}}
          onClose={() => setViewTicket(null)}
          ticketDetails={ticketDetails}
          timeline={timeline}
          loadTicketData={(id) => {
            getTicketDetails(id);
            getComplaintDetails(ticketDetails);
          }}
        />
      )}
    </>
  );
};

export default ServiceTickets;
